// NPM Imports
import React from "react";

// Components Imports
import DocumentBlocks from "../DocumentBlocks";

// Internal Imports
import { DOCUMENT_BLOCKS } from "../constants";
import ToggleComponentLockCommand from "../../../commands/toggleComponentLockCommand";
import ReOrderComponentInBodyCommand from "../../../commands/reOrderComponentInBodyCommand";
import { updateComponentOrder } from "../../../actions/DocumentActions/index";

class BodyView extends React.Component {
  _onPlaceholderDrop = (rowIndex, colIndex, newRow, dbRowIndex, dbColIndex) => {
    const {
      draggedSection,
      draggedFrom,
      draggedRowIndex,
      draggedColumnIndex,
    } = this.props;
    if (draggedFrom === "new-component") {
      this.props.addComponent(
        this.props.draggedSection,
        rowIndex,
        colIndex,
        newRow,
        dbRowIndex,
        dbColIndex,
      );
      this.props.clearDragDropData();
    } else {
      const reOrderComponentCommand = new ReOrderComponentInBodyCommand({
        draggedTo: "doc-component",
        layout: JSON.parse(JSON.stringify(this.props.layout)),
        rowIndex,
        colIndex,
        newRow,
        dbRowIndex,
        dbColIndex,
        draggedSection,
        draggedFrom,
        draggedRowIndex,
        draggedColumnIndex,
        updateComponentOrder: updateComponentOrder(this.props.mode),
        reOrderSectionListAction: this.props.reOrderSectionListAction,
        updateDraggedSection: this.props.updateDraggedSection,
      });
      this.props.executeCommand(reOrderComponentCommand);
    }
  };

  _handleComponentLockUnlock = (section, lockStatus) => {
    if (section) {
      const toggleComponentLockCommand = new ToggleComponentLockCommand({
        toggleComponentLockUnlock: this.props.toggleComponentLockUnlock,
        payload: {
          lockStatus,
          activeComponentID: section.id,
          activeComponentType: section.type,
          oldSection: section,
          isBodyView: true,
        },
      });
      this.props.executeCommand(toggleComponentLockCommand);
    }
  };

  render = () => (
    <div>
      <DocumentBlocks
        layout={this.props.layout}
        components={this.props.components}
        id={DOCUMENT_BLOCKS.BODY}
        blockType={DOCUMENT_BLOCKS.BODY}
        mode={this.props.mode}
        itemType="doc-component"
        componentMeta={{
          blockType: DOCUMENT_BLOCKS.BODY,
          itemType: "doc-component",
        }}
        isLocked={this.props.isLocked}
        addComponent={this.props.addComponent}
        updateComponent={this.props.updateComponent}
        deleteComponent={this.props.deleteComponent}
        cloneSection={this.props.cloneSection}
        removeHighlightSelection={this.props.removeHighlightSelection}
        updateHoveredSectionId={this.props.updateHoveredSectionId}
        removeActiveComponents={this.props.removeActiveComponents}
        showDocumentDiffView={this.props.showDocumentDiffView}
        deleteSection={this.props.deleteSection}
        isSharedDocument={this.props.isSharedDocument}
        isDocumentLocked={this.props.isDocumentLocked}
        updateTemplateDocSectionLockUnlock={
          this.props.updateTemplateDocSectionLockUnlock
        }
        hoveredActiveComponentId={this.props.hoveredActiveComponentId}
        // Refs related props
        customToolbarRef={this.props.customToolbarRef}
        setRefsByType={this.props.setRefsByType}
        signatureWrapperRef={this.props.signatureWrapperRef}
        // ------- Drag & Drop related props -------
        draggedSection={this.props.draggedSection}
        draggedPosition={this.props.draggedPosition}
        dragggedOverData={this.props.dragggedOverData}
        onPlaceholderDragEnter={this.props.onPlaceholderDragEnter}
        onPlaceholderDragLeave={this.props.onPlaceholderDragLeave}
        onPlaceholderDrop={this._onPlaceholderDrop}
        // Template related props
        handleComponentLockUnlock={this._handleComponentLockUnlock}
        tableColorpickerDropdownRef={this.props.tableColorpickerDropdownRef}
        match={this.props.match}
      />
    </div>
  );
}

export default BodyView;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/BodyView/BodyView.js